(function () {
  'use strict';

  angular.module('datepicker', []);
})();
